import type { PaymentFrequency } from '@backmarket/http-api/src/api-specs-insurance/types'

export type InsuranceBillingType =
  | 'monthly'
  | 'one_time'
  | 'annually'
  | 'biannually'
  | ''

/**
 * Maps an insurance `PaymentFrequency` to its lowercase GA4 tracking label:
 *   - MONTHLY    → 'monthly'
 *   - UPFRONT    → 'one_time'
 *   - ANNUALLY   → 'annually'
 *   - BIANNUALLY → 'biannually'
 *
 */
export function getInsuranceBillingType(
  paymentFrequency: PaymentFrequency,
): InsuranceBillingType {
  switch (paymentFrequency) {
    case 'MONTHLY':
      return 'monthly'
    case 'UPFRONT':
      return 'one_time'
    case 'ANNUALLY':
      return 'annually'
    case 'BIANNUALLY':
      return 'biannually'
    default:
      return ''
  }
}
